import { Controller } from 'stimulus';

export default class extends Controller {
  
  connect() {
    if (this.element.dataset.scrollToBottom !== undefined) {
      // new article
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("refresh-sortable"));
        this.element.scrollTop = this.element.scrollHeight;
      }, 0);
    }
  }
}